// React for Website

import React from "react";
//outsource
import { Row, Col, Input } from "antd";

//components
const { Search } = Input;

const SearchVoucher = ({ search, setSearch }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Search
      style={{ width: "100%" }}
      placeholder="Search by Voucher Reference (6 digit) | Customer's Telephone"
      onChange={(e) => setSearch(e.target.value)}
      value={search}
    />
  );
};

export default SearchVoucher;
